const getUtmCookies = () => {
  const referrer = Cookies.get('__gtm_referrer') || ''
  const raw_utm_string = Cookies.get('__gtm_campaign_url') || ''

  return {
    referrer,
    raw_utm_string
  }
}

export default getUtmCookies
